exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media print{.cremation-main .content+div,.nav,.progress-section,footer{display:none!important}}", ""]);

// exports
